module.exports = __webpack_public_path__ + "static/media/readingtrackerpic.eb061af5.png";